<div class="m-3 d-flex flex-column gap-2">
  <h1>{{ 'team' | translate }}</h1>

  <mat-card>
    <div class="bg-white rounded shadow">
      <app-tabs (onSelectTab)="onChangeTab($event)" [tabList]="tabs" />
    </div>

    @switch (activeTab && activeTab.value) {
      @case (TeamTab.MANAGERS) {
        @if (teamLoader) {
          <div class="flex-fill d-flex justify-content-center align-items-center" style="height: 50dvh">
            <app-loader></app-loader>
          </div>
        }
        @if (!teamLoader) {
          <app-tab-managers></app-tab-managers>
        }
      }
      @case (TeamTab.GROUPS) {
        @if (teamLoader) {
          <div class="flex-fill d-flex justify-content-center align-items-center" style="height: 50dvh">
            <app-loader></app-loader>
          </div>
        }
        @if (!teamLoader) {
          <app-tab-groups></app-tab-groups>
        }
      }
    }
  </mat-card>
</div>
